// extracted by mini-css-extract-plugin
module.exports = {"search_box":"search_box-2MSzjeF8","text":"text-30X3yoPg","btn":"btn-1ivmxrbQ","search":"search-3IloEEqQ"};